import { call, put } from '@redux-saga/core/effects'

export default function* getData(dispatchAction, endpoint, id, filters) {
  try {
    const body = yield call(endpoint, id, filters)
    const data = body.data
    yield put(dispatchAction(id, data))
  } catch (error) {
    yield put(dispatchAction(id, []))
  }
}
